import classes from './input-wrapper.module.css'

const InputWrapper = {
  classNames: {
    label: classes.label,
    description: classes.description,
  },
}

export default InputWrapper
